import React, { useState } from "react";
import Footer from "../../components/footer/Footer";

const ComoFunciona = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleAccordion = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  const AccordionItem = ({ id, title, content }) => {
    const isOpen = activeId === id;
    return (
      <div className="itemWrapper">
        <div className="item" onClick={() => toggleAccordion(id)}>
          <div className="iconCircle">✓</div>
          <span className="questionText">{title}</span>
        </div>
        <div className={`content ${isOpen ? "open" : ""}`}>{content}</div>
      </div>
    );
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <style>{`
        .container { padding: 40px; color: #333; margin: -30px auto; display: flex; gap: 50px; }
        .mainContent { flex: 2; }
        .title { font-size: 26px; font-weight: bold; margin-bottom: 30px; }
        .sectionTitle { font-size: 20px; font-weight: bold; margin: 30px 0 15px 0; }
        .itemWrapper { margin-bottom: 10px; overflow: hidden; }
        .item { display: flex; align-items: center; cursor: pointer; padding: 1px 0px; user-select: none; }
        .iconCircle { background-color: #00d1b2; color: white; width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 12px; font-size: 12px; flex-shrink: 0; }
        .questionText { font-size: 15px; font-weight: 500; color: #444; }
        .content { max-height: 0; opacity: 0; transition: all 0.3s ease-in-out; padding-left: 32px; font-size: 14px; color: #666; line-height: 1.6; }
        .content.open { max-height: 500px; opacity: 1; padding-top: 10px; padding-bottom: 10px; }
        .landing-sidebar { flex: 1; max-width: 300px; }
        .card { box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2); background-color: rgba(255, 255, 255, 0.06); padding: 15px 30px; border-radius: 30px; position: relative; top: 100px; }
        .cardTitle { font-weight: bold; margin-bottom: 15px; }
        .link { display: block; color: #007bff; text-decoration: none; margin-bottom: 12px; cursor: pointer; font-size: 14px; }
        @media (max-width: 935px) { .landing-sidebar { display: none } .container { margin-left: -10px } }
        @media (min-width: 981px) and (max-width: 1199px) { .container { width: 900px } }
        @media (min-width: 1200px) and (max-width: 1439px) { .container { width: 1080px } }
        @media (min-width: 1440px) { .container { width: 1240px } }
      `}</style>

      <div className="container">
        <div className="mainContent">
          <h1 className="title">Como funciona</h1>

          <section id="enviar" style={{ marginLeft: 20 }}>
            <h2 className="sectionTitle">1. Enviar encomendas</h2>
            <AccordionItem
              id="s1q1"
              title="Como envio uma encomenda?"
              content="Após encontrar em nosso buscador o viajante que poderá levar sua encomenda até o destino que você deseja, basta efetuar o pagamento da contribuição financeira que o viajante e ele será notificado da sua demanda e efetuará o pagamento do seguro (valor que você atribuiu a sua encomenda). Depois, você será notificado e pronto. Basta encontrar com o viajante, mostrar a encomenda pra ele e deixar ele averiguar, tirar 4 fotos da encomenda na presença dele e anexar no seu painel no site ou aplicativo e após o viajante confirmar que está recebendo a encomenda conforme as fotos (ele faz isso no painel dele no site ou aplicativo), você indica a pessoa de destinatário (quem vai receber a encomenda) e acompanhar em tempo real o deslocamento da sua encomenda até o destinatário. Ah, se quiser, podem usar o chat juntos (você, viajante e destinatário) para irem alinhando o encontro deles para entrega."
            />
            <AccordionItem
              id="s1q2"
              title="Quanto pagarei para enviar minha encomenda?"
              content="O valor pela contribuição ao viajante leva em consideração diversas variáveis, entre elas, o meio de transporte, a distância, o tipo de encomenda, dentre outros. Entretanto, o “valor de seguro “que você atribui a sua encomenda (e que você irá receber em caso de extravio ou roubo) tem forte influência no valor da contribuição que lhe será cobrada. Assim, procure ser justo colocando um valor que não inviabilize o interesse dos viajantes em levar sua encomenda."
            />
            <AccordionItem
              id="s1q3"
              title="Como efetuo o pagamento?"
              content="Você efetua o pagamento da contribuição ao viajante no momento em que confirmar a solicitação através de uma pré-autorização no Cartão de Crédito ou mediante PIX. Fique tranquilo, caso o viajante não aceite levar sua encomenda por qualquer motivo e declinar da sua demanda, o valor será estornado no seu cartão de crédito ou transferido para sua conta, no caso de PIX."
            />
            <AccordionItem
              id="s1q4"
              title="Como acompanho o trajeto da encomenda?"
              content="Diferente de todos os outros meios de envio de encomenda, na GoinBag você poderá acompanhar em tempo real o deslocamento de sua encomenda (depende de acesso a internet das partes) através do site ou do aplicativo. Não só isso, as partes envolvidas (cliente, viajante e destinatário) podem trocar mensagens em nosso chat sempre tirando dúvidas entre si e alinhando o encontro para entrega da encomenda."
            />
            <AccordionItem
              id="s1q5"
              title="Como a encomenda é recepcionada no destino?"
              content="Após o cliente (demandante) efetivar o pagamento da contribuição ao viajante e o viajante efetivar o pagamento da “reserva do valor do seguro da encomenda”, o cliente (demandante) incluirá no painel pelo site ou aplicativo os dados da pessoa destinatária da encomenda (nome, e-mail, telefone e CPF) que será notificada e acompanhará os detalhes e deslocamento em tempo real do envio da encomenda. O cliente (demandante) deverá, previamente, entrar em contato pessoalmente com a pessoa destinatária que deverá ser, preferencialmente, algum familiar ou conhecimento do cliente (demandante)."
            />
            <AccordionItem
              id="s1q6"
              title="Qual a garantia que tenho caso a encomenda seja extraviada ou roubada"
              content="Aqui entra um método simples e seguro para o envio de suas encomendas. Simples, por que você vai atribuir um valor, de forma justa, a sua encomenda que servirá de “Seguro da Encomenda”. Seguro, por que o viajante, para aceitar levar sua encomenda, tem que reservar o valor do “Seguro da Encomenda” que você atribuiu em uma conta temporária na GoinBag e caso a sua encomenda seja extraviada ou roubada o valor reservado para o “Seguro da Encomenda” será transferido para sua conta via PIX em até 2 dias depois do trânsito finalizado."
            />
            <AccordionItem
              id="s1q7"
              title="Vou enviar Documentos sem valor comercial, como fica o seguro neste caso"
              content="Encomendas em papel como documentos em geral tipo certidões, contratos, certificados, Atas, etc, por não ter valor comercial e ser exclusivamente pessoal e inegociável, não corre risco de ser furtado pelo viajante. Então, para facilitar ainda mais a aceitação do viajante em levar sua encomenda e reduzir seus custos com o valor da contribuição, neste caso, não se atribui “Valor do Seguro da Encomenda”."
            />
            <AccordionItem
              id="s1q8"
              title="Posso enviar diversos produtos de uma única vez mesmo com Nota Fiscal"
              content="A GoinBag é um sistema inteligente que apenas encontra quem tem espaço livre e que está indo ao destino que lhe interessa e que tem espaço para levar sua encomenda na viagem. Não somos uma empresa de logística, pois não levamos encomendas e nem nos responsabilizamos por elas. O envio de encomendas comerciais não é indicado e nem aconselhado tendo em vista que a legislação vigente pode exigir tributos entre estados ou entre países para o deslocamento de produtos. Desta forma, toda nossa orientação é que não seja enviado e nem aceito pelos viajantes encomendas que tenhas fins comerciais."
            />
            <AccordionItem
              id="s1q9"
              title="Posso cancelar uma solicitação que o viajante já aceitou levar"
              content="Sim, entretanto, como a GoinBag não é empresa de logística (não transportamos encomendas), já teríamos cumprido e prestado nosso serviço: Encontrar alguém que tenha espaço na viajem e queira levar sua encomenda até o destino que você deseja onde o viajante já teria reservado um valor no cartão de crédito dele caso sua encomenda seja roubada ou extraviada. Assim, em caso de seu cancelamento, um pequeno valor correspondente a 25% da contribuição pelo serviço anteriormente realizada por você (viajante) será descontado, mas o restante será imediatamente estornado no cartão de crédito ou via transferência PIX a depender da forma utilizada na efetivação."
            />
          </section>

          <section id="disponibilizar" style={{ marginLeft: 20 }}>
            <h2 className="sectionTitle">
              2. Disponibilizar meu espaço e levar encomendas
            </h2>
            <AccordionItem
              id="s2q1"
              title="Como disponibilizo meu espaço da viagem?"
              content="É simples e rápido, basta fazer seu cadastro em nossa plataforma e cadastrar a sua mala informando o tipo de transporte que irá viajar, o dia, local e hora de origem e destino, espaço disponível e incluir um texto interessante falando de você e de sua viagem. Assim que aparecer demanda no seu trajeto de deslocamento o sistema irá te avisar através de notificações para continuidade do procedimento."
            />
            <AccordionItem
              id="s2q2"
              title="Quanto receberei por levar encomendas?"
              content="O valor da contribuição que você irá receber varia e leva em consideração diversos fatores, entre eles, o meio de transporte, a distância, o tempo, o tipo de encomenda, o valor do seguro atribuído pelo cliente (demandante), dentre outros. Mas fique certo que será um apoio extra vantajoso para você que tem espaço livre e já vai ter que fazer a viagem de qualquer jeito."
            />
            <AccordionItem
              id="s2q3"
              title="Tenho que pagar algo para poder levar encomendas?"
              content="Não, desde que a encomenda não seja roubada nem extraviada/avariada. O único responsável por levar a encomenda é o viajante e por isso é necessário apenas uma pré-aprovação no cartão de crédito ou uma transferência temporária via PIX para reserva do “Valor do Seguro da Encomenda” que será utilizada apenas em caso de roubo ou extravio da encomenda. Acreditamos que não será o seu caso, mas já pensou se o viajante “gostar muito” da encomenda e resolve ficar, é necessário um reembolso ao cliente (demandante) não é mesmo? Mas tudo correndo bem e a entrega sendo efetivada ao destinatário, instantaneamente a pré-autorização no cartão de crédito é liberada ou a transferência via PIX é estonada."
            />
          </section>

          <section id="receber" style={{ marginLeft: 20 }}>
            <h2 className="sectionTitle">3. Receber encomendas</h2>
            <AccordionItem
              id="s3q1"
              title="Ganho alguma coisa por receber encomenda"
              content="Não, você enquanto destinatário é um amigo ou familiar do cliente (demandante) que conta com seu apoio para que de direcionamento a encomenda enviada."
            />
            <AccordionItem
              id="s3q2"
              title="Fui notificado, mas não conheço o cliente (demandante)"
              content="Neste caso, indicamos que imediatamente envie uma mensagem ao cliente (demandante) informando que desconhece o contato."
            />
            <AccordionItem
              id="s3q3"
              title="Não consigo estar no locar e hora marcados para pegar a encomenda"
              content="Nesta situação, indicamos que imediatamente entre em contato com o cliente (demandante) para que este possa incluir nossa pessoa destinatária no sistema. Quando mais rápido você informa da indisponibilidade ao cliente (demandante) menos constrangimentos terão."
            />
            <AccordionItem
              id="s3q4"
              title="A encomenda não está conforme as fotos tiradas no momento da entrega para o viajante"
              content="Neste caso, deverá tirar fotos de como recebeu a encomenda e anexar no seu painel no site ou aplicativo para que o cliente possa averiguar no painel dele se aceita receber a encomenda conforme as fotos, se não aceitar, o destinatário deve recusar o recebimento e incluir no painel que o produto está avariado, situação que causará o pagamento para o cliente (demandante) do “Valor do Seguro da Encomenda” e a não entrega, pelo viajante, da encomenda ao destinatário."
            />
          </section>
        </div>

        <div className="landing-sidebar">
          <div className="card">
            <h3 className="cardTitle">Atalho</h3>
            <a onClick={() => scrollToSection("enviar")} className="link">
              Enviar encomendas
            </a>
            <a
              onClick={() => scrollToSection("disponibilizar")}
              className="link"
            >
              Disponibilizar meu espaço e levar encomendas
            </a>
            <a onClick={() => scrollToSection("receber")} className="link">
              Receber encomendas
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ComoFunciona;
